// Utility function to filter reviews by platform
export const filterReviewsByPlatform = (reviews) => {
    
    const gygReviews = [];
    const headoutReviews = [];
    const tiqetsReviews = [];
    const viatorReviews = [];
    const civitatisReviews = [];
    const musemetReviews = [];
    const airbnbReviews = [];

  
    reviews.forEach((review) => {
      // Check if review is valid
      if (Array.isArray(review) && review.length > 1) {
        const productCode = review[1]; // Get the product code from the second position
  
        // Check the type of productCode
        if (typeof productCode === 'string' || typeof productCode === 'number') {
          // Convert productCode to string for consistent checks
          const productCodeStr = String(productCode).toUpperCase();
  
          if (productCodeStr.startsWith('GYG')) {
            gygReviews.push(review);
          } else if (productCodeStr.startsWith('HEA')) {
            headoutReviews.push(review);
          } else if (productCodeStr.includes('TIQ')) {
            tiqetsReviews.push(review);
          } else if(productCodeStr.startsWith('CIV')){
            civitatisReviews.push(review)
          } else if(productCodeStr.startsWith('MUS')){
            musemetReviews.push(review)
          } else if(productCodeStr.startsWith('ABNB')){
            airbnbReviews.push(review)
          } else {
            viatorReviews.push(review);
          }
        } else {
          console.warn(`Invalid product code type for review:`, review, 'Type:', typeof productCode);
        }
      } else {
        console.warn(`Invalid review structure:`, review);
      }
    });
  
    return { gygReviews, headoutReviews, tiqetsReviews, viatorReviews, civitatisReviews, musemetReviews, airbnbReviews };
  };
  